import { makeStyles } from '@material-ui/core';
import { SIcon } from './Icon';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    background: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: `url("/images/background.png")`,
        [theme.breakpoints.up('md')]: {
            width: '100%',
            left: '0',
        },
    },
    logoSection: {
        textAlign: 'center',
        marginTop: '30vh',
        '& div': {
            paddingTop: '2vh',
            fontSize: '18px',
            fontFamily: 'NanumB',
        },
    },
    footer: {
        position: 'absolute',
        textAlign: 'center',
        bottom: '5vh',
        left: 0,
        right: 0,
    },
}));

const SplashFoundation: React.FC<any> = (props) => {
    const classes = useStyles();

    const { companyName } = props;
    return (
        <div className={classes.background}>
            <div className={classes.logoSection}>
                <img
                    src="/images/building.png"
                    style={{ background: 'transparent' }}
                />
                <div>
                    '{companyName}' 기업 설립이
                    <br />
                    완료되었습니다!
                </div>
            </div>

            <div className={classes.footer}>
                <SIcon type="P" />
            </div>
        </div>
    );
};

export default SplashFoundation;
